import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './PasswordReset.css';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Use environment variable for API base URL
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const { email, otpCode } = location.state || {};
    if (email && otpCode) {
      setEmail(email);
      setOtpCode(otpCode);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!newPassword || !confirmPassword) {
      setError('Please fill in both password fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setIsLoading(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('otp_code', otpCode);
      formData.append('new_password', newPassword);

      // ✅ Keep using axios for this unauthenticated endpoint
      const response = await axios.post(
        `${API_BASE_URL}/users/users/password-reset/reset`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      setSuccess(response.data?.message || 'Password reset successful!');
      setTimeout(() => navigate('/Login'), 1500);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map(d => d.msg).join(', '));
      } else {
        setError(
          detail ||
          err.response?.data?.new_password?.[0] ||
          'Password reset failed.'
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="otp-container">
      <form className="otp-form" onSubmit={handleSubmit}>
        <h2>🔐 Reset Password</h2>
        <p className="otp-message">Enter your new password below</p>

        {error && <div className="otp-error">{error}</div>}
        {success && <div className="otp-success">{success}</div>}

        <input type="hidden" value={email} readOnly />
        <input type="hidden" value={otpCode} readOnly />

        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
          required
          disabled={isLoading}
          style={{ width: '100%', maxWidth: '300px', marginBottom: '10px' }}
        />

        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          required
          disabled={isLoading}
          style={{ width: '100%', maxWidth: '300px', marginBottom: '20px' }}
        />

        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
    </div>
  );
};

export default PasswordReset;